import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';

function DriverEmail() {
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow">
            <div className="card-body">
              <h3 className="card-title text-center mb-4">Driver Email</h3>
              
              <form>
                <div className="mb-3">
                  <label htmlFor="driverEmail" className="form-label">
                    Enter Driver Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="driverEmail"
                    placeholder="name@example.com"
                  />
                </div>
                
                <div className="d-grid">
                  <button 
                    type="submit" 
                    className="btn btn-primary btn-lg"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DriverEmail